"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastPromo = void 0;
var getLastPromo = function (lastRotations, adcampaignId) {
    var adRotations = lastRotations.filter(function (r) { return r.adcompanyId == adcampaignId; });
    if (!adRotations.length) {
        return null;
    }
    return adRotations.sort(function (a, b) { return (a.playtime < b.playtime ? 1 : -1); })[0];
};
exports.getLastPromo = getLastPromo;
//# sourceMappingURL=getLastPromo.js.map